import * as React from 'react';

export const coursesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6341 3.08638C11.8644 2.97121 12.1356 2.97121 12.3659 3.08638L20.5476 7.1772C21.1506 7.47872 21.1506 8.33927 20.5476 8.64078L12.3659 12.7316C12.1356 12.8468 11.8644 12.8468 11.6341 12.7316L3.45245 8.64078C2.84942 8.33927 2.84942 7.47872 3.45245 7.1772L11.6341 3.08638ZM5.64782 7.90899L12 11.0851L18.3522 7.90899L12 4.7329L5.64782 7.90899ZM19.8158 15.3589C20.2199 15.1568 20.7114 15.3206 20.9134 15.7248C21.1155 16.1289 20.9517 16.6204 20.5476 16.8224L12.3659 20.9133C12.1356 21.0284 11.8644 21.0284 11.6341 20.9133L3.45245 16.8224C3.04829 16.6204 2.88448 16.1289 3.08656 15.7248C3.28863 15.3206 3.78008 15.1568 4.18424 15.3589L12 19.2667L19.8158 15.3589ZM19.8158 11.268C20.2199 11.066 20.7114 11.2298 20.9134 11.6339C21.1155 12.0381 20.9517 12.5295 20.5476 12.7316L12.3659 16.8224C12.1356 16.9376 11.8644 16.9376 11.6341 16.8224L3.45245 12.7316C3.04829 12.5295 2.88448 12.0381 3.08656 11.6339C3.28863 11.2298 3.78008 11.066 4.18424 11.268L12 15.1759L19.8158 11.268Z"
    />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="3"
      y="3"
      width="18"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6341 3.08638C11.8644 2.97121 12.1356 2.97121 12.3659 3.08638L20.5476 7.1772C21.1506 7.47872 21.1506 8.33927 20.5476 8.64078L12.3659 12.7316C12.1356 12.8468 11.8644 12.8468 11.6341 12.7316L3.45245 8.64078C2.84942 8.33927 2.84942 7.47872 3.45245 7.1772L11.6341 3.08638ZM5.64782 7.90899L12 11.0851L18.3522 7.90899L12 4.7329L5.64782 7.90899ZM19.8158 15.3589C20.2199 15.1568 20.7114 15.3206 20.9134 15.7248C21.1155 16.1289 20.9517 16.6204 20.5476 16.8224L12.3659 20.9133C12.1356 21.0284 11.8644 21.0284 11.6341 20.9133L3.45245 16.8224C3.04829 16.6204 2.88448 16.1289 3.08656 15.7248C3.28863 15.3206 3.78008 15.1568 4.18424 15.3589L12 19.2667L19.8158 15.3589ZM19.8158 11.268C20.2199 11.066 20.7114 11.2298 20.9134 11.6339C21.1155 12.0381 20.9517 12.5295 20.5476 12.7316L12.3659 16.8224C12.1356 16.9376 11.8644 16.9376 11.6341 16.8224L3.45245 12.7316C3.04829 12.5295 2.88448 12.0381 3.08656 11.6339C3.28863 11.2298 3.78008 11.066 4.18424 11.268L12 15.1759L19.8158 11.268Z"
      />
    </mask>
    <g mask="url(#mask0)" />
  </svg>
);

export const searchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 10.3075C3 6.27166 6.27166 3 10.3075 3C14.3433 3 17.6149 6.27166 17.6149 10.3075C17.6149 11.9526 17.0713 13.4708 16.1539 14.6921C16.1582 14.6954 16.1626 14.6987 16.1669 14.7021L16.2652 14.7889L20.6942 19.2179C21.1019 19.6256 21.1019 20.2866 20.6942 20.6942C20.3179 21.0706 19.7258 21.0995 19.3163 20.7811L19.2179 20.6942L14.7889 16.2652C14.7536 16.2299 14.7213 16.1927 14.6921 16.1539C13.4708 17.0713 11.9526 17.6149 10.3075 17.6149C6.27166 17.6149 3 14.3433 3 10.3075ZM10.3075 5.08785C13.1902 5.08785 15.5271 7.42475 15.5271 10.3075C15.5271 13.1902 13.1902 15.5271 10.3075 15.5271C7.42475 15.5271 5.08785 13.1902 5.08785 10.3075C5.08785 7.42475 7.42475 5.08785 10.3075 5.08785Z"
    />
  </svg>
);

export const moreIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8H19.5C20.3284 8 21 7.32843 21 6.5C21 5.67157 20.3284 5 19.5 5H4.5ZM3 12.5C3 11.6716 3.67157 11 4.5 11H19.5C20.3284 11 21 11.6716 21 12.5C21 13.3284 20.3284 14 19.5 14H4.5C3.67157 14 3 13.3284 3 12.5ZM3 18.5C3 17.6716 3.67157 17 4.5 17H19.5C20.3284 17 21 17.6716 21 18.5C21 19.3284 20.3284 20 19.5 20H4.5C3.67157 20 3 19.3284 3 18.5Z"
    />
  </svg>
);

export const screenIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1.71429H6.53062C6.53062 1.25962 6.70262 0.8236 7.0088 0.502107C7.31499 0.180612 7.73026 0 8.16326 0C8.59627 0 9.01154 0.180612 9.31773 0.502107C9.62391 0.8236 9.79591 1.25962 9.79591 1.71429H16.3265V3.42857H15.5102V12.8572H10.8163L12.2449 18H10.6122L9.18367 12.8572H7.14286L5.71428 18H4.08164L5.5102 12.8572H0.816326V3.42857H0V1.71429ZM2.44897 3.42857V11.1429H13.8775V3.42857H2.44897Z"
      fill="#2A3030"
    />
  </svg>
);

export const trelloIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.75 0H2.25C1.65327 0 1.08096 0.237053 0.65901 0.659002C0.237053 1.08097 0 1.65326 0 2.25V15.75C0 16.3467 0.237053 16.9191 0.65901 17.3409C1.08096 17.7629 1.65327 18 2.25 18H15.75C16.3468 18 16.9191 17.7629 17.3411 17.3409C17.7629 16.9191 18 16.3467 18 15.75V2.25C18 1.65326 17.7629 1.08097 17.3411 0.659002C16.9191 0.237053 16.3468 0 15.75 0ZM7.83001 13.68C7.83001 13.9663 7.71622 14.2411 7.51368 14.4437C7.31114 14.6462 7.03644 14.76 6.75001 14.76H3.42C2.826 14.76 2.34 14.274 2.34 13.68V3.41999C2.34 3.13356 2.45379 2.85886 2.65633 2.65632C2.85886 2.45378 3.13357 2.33999 3.42 2.33999H6.75001C7.34401 2.33999 7.83001 2.82599 7.83001 3.41999V13.68ZM15.66 9.17998C15.66 9.77398 15.174 10.26 14.58 10.26H11.25C10.656 10.26 10.17 9.77398 10.17 9.17998V3.41999C10.17 2.82599 10.656 2.33999 11.25 2.33999H14.58C15.174 2.33999 15.66 2.82599 15.66 3.41999V9.17998Z"
      fill="#2A3030"
    />
  </svg>
);

export const chatIcon = (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#2A3030"
      stroke="none"
    >
      <path
        d="M2945 5109 c-379 -36 -732 -165 -1037 -379 -142 -99 -347 -309 -442
-453 -165 -248 -255 -534 -256 -810 l0 -77 -43 -17 c-78 -30 -266 -132 -359
-194 -414 -275 -684 -657 -780 -1103 -29 -136 -31 -423 -4 -566 52 -269 190
-561 361 -759 l46 -54 -29 -31 c-104 -111 -385 -442 -392 -462 -26 -68 6 -151
70 -184 39 -20 57 -20 1113 -20 1016 0 1083 1 1223 20 532 71 974 285 1315
636 210 216 350 458 425 730 28 103 54 278 54 367 l0 57 398 0 c368 0 400 1
432 19 68 36 98 127 64 193 -9 18 -97 125 -196 240 l-179 209 39 44 c145 165
272 427 324 668 29 136 31 398 5 531 -75 371 -275 694 -587 945 -419 337
-1003 505 -1565 450z m415 -300 c433 -44 814 -218 1090 -498 374 -379 471
-887 255 -1338 -56 -117 -122 -215 -222 -328 -94 -106 -103 -121 -103 -173 0
-48 20 -79 143 -222 50 -58 97 -113 105 -122 14 -17 3 -18 -219 -18 l-235 0
-18 73 c-140 551 -629 1034 -1267 1251 -246 83 -479 120 -774 120 -223 1 -310
-7 -499 -45 -54 -11 -101 -17 -104 -14 -11 10 27 231 53 310 65 197 163 354
325 515 222 223 499 373 830 449 73 17 152 30 275 44 68 8 270 6 365 -4z
m-1044 -1560 c385 -37 752 -178 1031 -395 538 -420 708 -1068 427 -1628 -249
-495 -781 -836 -1422 -911 -103 -12 -292 -15 -1000 -15 l-873 0 140 159 c77
88 145 169 151 182 7 12 10 44 8 74 -4 49 -9 57 -102 161 -192 214 -299 416
-352 664 -25 118 -26 363 -1 480 81 379 327 711 697 941 363 226 843 332 1296
288z"
      />
      <path
        d="M1113 2092 c-251 -90 -272 -432 -35 -549 81 -40 183 -40 264 0 107
53 163 144 163 267 0 85 -21 142 -74 203 -72 81 -213 117 -318 79z"
      />
      <path
        d="M2013 2092 c-251 -90 -272 -432 -35 -549 81 -40 183 -40 264 0 107
53 163 144 163 267 0 85 -21 142 -74 203 -72 81 -213 117 -318 79z"
      />
      <path
        d="M2913 2092 c-251 -90 -272 -432 -35 -549 81 -40 183 -40 264 0 107
53 163 144 163 267 0 85 -21 142 -74 203 -72 81 -213 117 -318 79z"
      />
    </g>
  </svg>
);

export const calendarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.55556 8.10001H8V12.6H3.55556V8.10001ZM14.2223 16.2H1.77777V6.30001H14.2223V16.2ZM14.2223 1.80001H13.3333V0H11.5556V1.80001H4.44444V0H2.66667V1.80001H1.77777C0.791111 1.80001 0 2.61001 0 3.60001V16.2C0 16.6774 0.187301 17.1353 0.520699 17.4728C0.854097 17.8105 1.30628 18 1.77777 18H14.2223C14.6937 18 15.1459 17.8105 15.4793 17.4728C15.8127 17.1353 16 16.6774 16 16.2V3.60001C16 3.12262 15.8127 2.66478 15.4793 2.32721C15.1459 1.98964 14.6937 1.80001 14.2223 1.80001Z"
      fill="#2A3030"
    />
  </svg>
);

export const githubIcon = (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.22345 0C8.01221 0 6.81283 0.238571 5.69379 0.702093C4.57475 1.16562 3.55796 1.84501 2.70149 2.70149C0.971749 4.43121 0 6.77723 0 9.22344C0 13.3002 2.64713 16.7589 6.30883 17.9857C6.77001 18.0595 6.91758 17.7736 6.91758 17.5246C6.91758 17.3124 6.91758 16.7313 6.91758 15.9658C4.36269 16.5192 3.8185 14.7299 3.8185 14.7299C3.39423 13.6599 2.7947 13.374 2.7947 13.374C1.95537 12.8021 2.85927 12.8206 2.85927 12.8206C3.78162 12.8852 4.27046 13.7705 4.27046 13.7705C5.0729 15.1726 6.42874 14.7576 6.95448 14.5362C7.03749 13.9366 7.27729 13.5308 7.53556 13.3002C5.48795 13.0696 3.33889 12.2764 3.33889 8.76227C3.33889 7.73847 3.68938 6.91759 4.2889 6.26271C4.19667 6.03214 3.87384 5.07289 4.38114 3.82772C4.38114 3.82772 5.15591 3.57869 6.91758 4.76852C7.64624 4.56561 8.43945 4.46414 9.22345 4.46414C10.0074 4.46414 10.8007 4.56561 11.5293 4.76852C13.291 3.57869 14.0657 3.82772 14.0657 3.82772C14.573 5.07289 14.2503 6.03214 14.158 6.26271C14.7575 6.91759 15.108 7.73847 15.108 8.76227C15.108 12.2856 12.9497 13.0604 10.8929 13.291C11.2249 13.5769 11.5293 14.1395 11.5293 14.9973C11.5293 16.2332 11.5293 17.2293 11.5293 17.5246C11.5293 17.7736 11.6769 18.0687 12.1473 17.9857C15.8089 16.7498 18.4469 13.3002 18.4469 9.22344C18.4469 8.01221 18.2084 6.81283 17.7447 5.69378C17.2813 4.57474 16.6018 3.55797 15.7454 2.70149C14.8889 1.84501 13.8721 1.16562 12.7531 0.702093C11.6341 0.238571 10.4347 0 9.22345 0Z"
      fill="#2A3030"
    />
  </svg>
);

export const testlinkIcon = (
  <svg
    id="regular"
    enableBackground="new 0 0 24 24"
    height="19"
    viewBox="0 0 24 24"
    width="19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m12 22c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10zm0-18.5c-4.687 0-8.5 3.813-8.5 8.5s3.813 8.5 8.5 8.5 8.5-3.813 8.5-8.5-3.813-8.5-8.5-8.5z" />
    <path d="m12 5c-.414 0-.75-.336-.75-.75v-3.5c0-.414.336-.75.75-.75s.75.336.75.75v3.5c0 .414-.336.75-.75.75z" />
    <path d="m23.25 12.75h-3.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.5c.414 0 .75.336.75.75s-.336.75-.75.75z" />
    <path d="m12 24c-.414 0-.75-.336-.75-.75v-3.5c0-.414.336-.75.75-.75s.75.336.75.75v3.5c0 .414-.336.75-.75.75z" />
    <path d="m4.25 12.75h-3.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.5c.414 0 .75.336.75.75s-.336.75-.75.75z" />
    <path d="m12 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z" />
  </svg>
);

export const jiraIcon = (
  <svg
    height="19"
    viewBox="2.59 0 214.09101008 224"
    width="19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <linearGradient
      id="a"
      gradientTransform="matrix(1 0 0 -1 0 264)"
      gradientUnits="userSpaceOnUse"
      x1="102.4"
      x2="56.15"
      y1="218.63"
      y2="172.39"
    >
      <stop offset=".18" stopColor="#383434" />
      <stop offset="1" stopColor="#383434" />
    </linearGradient>
    <linearGradient
      id="b"
      x1="114.65"
      x2="160.81"
      xlinkHref="#a"
      y1="85.77"
      y2="131.92"
    />
    <path
      d="m214.06 105.73-96.39-96.39-9.34-9.34-72.56 72.56-33.18 33.17a8.89 8.89 0 0 0 0 12.54l66.29 66.29 39.45 39.44 72.55-72.56 1.13-1.12 32.05-32a8.87 8.87 0 0 0 0-12.59zm-105.73 39.39-33.12-33.12 33.12-33.12 33.11 33.12z"
      fill="#383434"
    />
    <path
      d="m108.33 78.88a55.75 55.75 0 0 1 -.24-78.61l-72.47 72.44 39.44 39.44z"
      fill="url(#a)"
    />
    <path
      d="m141.53 111.91-33.2 33.21a55.77 55.77 0 0 1 0 78.86l72.67-72.63z"
      fill="url(#b)"
    />
  </svg>
);

export const recordsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 80 80"
    fill="none"
  >
    <path
      d="M54.0143 41.9687L35.9429 55.5034C34.3183 56.7201 32 55.5625 32 53.5347V26.4653C32 24.4375 34.3183 23.2799 35.9429 24.4966L54.0143 38.0313C55.3286 39.0157 55.3286 40.9843 54.0143 41.9687Z"
      fill="#2A3030"
    />
    <circle cx="40" cy="40" r="38.5" stroke="#2A3030" strokeWidth="3" />
  </svg>
);

export const profileIcon = (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1654 18H1.83517C0.823431 18 0 17.1783 0 16.1693V14.5727C0 11.7175 1.71316 9.17693 4.3634 8.10233L4.68487 7.60534L4.35783 8.04897C3.08536 7.11557 2.4118 5.61735 2.55498 4.0402C2.75554 1.83874 4.64977 0.0653448 6.86713 0.00196948C8.09837 -0.0336096 9.23769 0.413909 10.1102 1.26002C10.9832 2.10725 11.4645 3.24245 11.4645 4.45659C11.4645 5.86919 10.7826 7.21174 9.63994 8.04841L9.44104 8.61879L9.64941 8.10845C10.5146 8.46035 11.2885 8.97458 11.9515 9.63613C13.273 10.9542 14 12.7076 14 14.5727V16.1693C14 17.1783 13.1777 18 12.1654 18Z"
    />
  </svg>
);

export const editIcon = (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5274 0.244361C10.6925 0.0817142 10.9097 0 11.1263 0C11.343 0 11.5597 0.0817142 11.7252 0.244361L13.4664 1.95489C13.7966 2.27922 13.7966 2.80629 13.4664 3.13158L12.2457 4.33083L9.30671 1.44361L10.5274 0.244361ZM0.287008 10.3045L7.92142 2.80451L10.8604 5.69173L3.22597 13.1917C3.04277 13.3727 2.79293 13.4737 2.53332 13.4737H0.551055C0.246383 13.4737 0 13.2316 0 12.9323V10.985C0 10.7299 0.102833 10.4854 0.287008 10.3045ZM0.842105 14.3158C0.377023 14.3158 0 14.6928 0 15.1579C0 15.623 0.377024 16 0.842106 16H12.873C13.3381 16 13.7151 15.623 13.7151 15.1579C13.7151 14.6928 13.3381 14.3158 12.873 14.3158H0.842105Z"
    />
  </svg>
);

export const starIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0001 3C11.6853 3 11.3705 3.17177 11.2087 3.51433L8.90588 8.39602L3.75657 9.1788C3.03275 9.28874 2.74378 10.2192 3.2673 10.7537L6.99383 14.5537L6.1138 19.9188C6.01622 20.5156 6.46937 21 6.98351 21C7.11908 21 7.25934 20.9661 7.39444 20.892L12.0001 18.3587L16.6057 20.892C16.7408 20.9666 16.8806 21 17.0166 21C17.5308 21 17.9839 20.5156 17.8859 19.9188L17.0063 14.5537L20.7324 10.7537C21.2563 10.2192 20.9674 9.28874 20.2436 9.1788L15.0942 8.39602L12.7914 3.51433C12.6296 3.17177 12.3148 3 12.0001 3Z"
    />
  </svg>
);

export const outlineStarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0001 3C11.6853 3 11.3705 3.17177 11.2087 3.51433L8.90588 8.39602L3.75657 9.1788C3.03275 9.28874 2.74378 10.2192 3.2673 10.7537L6.99383 14.5537L6.1138 19.9188C6.01622 20.5156 6.46937 21 6.98351 21C7.11908 21 7.25934 20.9661 7.39444 20.892L12.0001 18.3587L16.6057 20.892C16.7408 20.9666 16.8806 21 17.0166 21C17.5308 21 17.9839 20.5156 17.8859 19.9188L17.0063 14.5537L20.7324 10.7537C21.2563 10.2192 20.9674 9.28874 20.2436 9.1788L15.0942 8.39602L12.7914 3.51433C12.6296 3.17177 12.3148 3 12.0001 3ZM12 5.46632L13.8439 9.39461C13.956 9.63321 14.1722 9.79833 14.4221 9.83669L18.5453 10.4665L15.5618 13.5243C15.3809 13.7101 15.2984 13.9773 15.341 14.2389L16.0452 18.5572L12.3575 16.5184C12.2454 16.4566 12.1225 16.4255 12 16.4255C11.8771 16.4255 11.7543 16.4566 11.6425 16.5184L7.95445 18.5572L8.65904 14.2389C8.70166 13.9773 8.61911 13.7101 8.43826 13.5243L5.45438 10.4665L9.57751 9.83669C9.82787 9.79833 10.044 9.63321 10.1558 9.39461L12 5.46632Z"
    />
  </svg>
);

export const chevronIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="6"
    viewBox="0 0 9 6"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.08098 1.10637C8.4715 1.49689 8.4715 2.13006 8.08098 2.52058L5.25255 5.34901C4.86203 5.73953 4.22886 5.73953 3.83834 5.34901L1.00991 2.52058C0.619387 2.13006 0.619387 1.49689 1.00991 1.10637C1.40044 0.715845 2.0336 0.715845 2.42413 1.10637L4.54545 3.22769L6.66677 1.10637C7.05729 0.715845 7.69045 0.715845 8.08098 1.10637Z"
    />
  </svg>
);

export const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.41 3.42462C11.9958 2.83883 11.9958 1.88909 11.41 1.3033C10.8242 0.717514 9.87446 0.717515 9.28867 1.3033L6.10669 4.48528L2.92471 1.3033C2.33892 0.717514 1.38918 0.717514 0.803389 1.3033C0.217602 1.88909 0.217603 2.83883 0.803389 3.42462L3.98537 6.6066L0.803389 9.78858C0.217602 10.3744 0.217602 11.3241 0.803389 11.9099C1.38918 12.4957 2.33892 12.4957 2.92471 11.9099L6.10669 8.72792L9.28867 11.9099C9.87446 12.4957 10.8242 12.4957 11.41 11.9099C11.9958 11.3241 11.9958 10.3744 11.41 9.78858L8.22801 6.6066L11.41 3.42462Z"
    />
  </svg>
);

export const smallCloseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 12 13"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.41 3.42462C11.9958 2.83883 11.9958 1.88909 11.41 1.3033C10.8242 0.717514 9.87446 0.717515 9.28867 1.3033L6.10669 4.48528L2.92471 1.3033C2.33892 0.717514 1.38918 0.717514 0.803389 1.3033C0.217602 1.88909 0.217603 2.83883 0.803389 3.42462L3.98537 6.6066L0.803389 9.78858C0.217602 10.3744 0.217602 11.3241 0.803389 11.9099C1.38918 12.4957 2.33892 12.4957 2.92471 11.9099L6.10669 8.72792L9.28867 11.9099C9.87446 12.4957 10.8242 12.4957 11.41 11.9099C11.9958 11.3241 11.9958 10.3744 11.41 9.78858L8.22801 6.6066L11.41 3.42462Z"
    />
  </svg>
);

export const checkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6982 7.18179C16.2839 6.596 16.2839 5.64625 15.6982 5.06047C15.1124 4.47468 14.1626 4.47468 13.5768 5.06047L6.1797 12.4576L3.7093 9.98721C3.12352 9.40143 2.17377 9.40143 1.58798 9.98721C1.0022 10.573 1.0022 11.5227 1.58798 12.1085L4.87812 15.3987C4.93755 15.494 5.00869 15.5842 5.09156 15.6671C5.62361 16.1991 6.4559 16.2479 7.04304 15.8135C7.11394 15.7639 7.18152 15.7074 7.24484 15.6441C7.27792 15.611 7.30913 15.5767 7.33848 15.5415L15.6982 7.18179Z"
    />
  </svg>
);

export const touchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 84.91 122.88"
  >
    <g>
      <path d="M26.6,80.57c-0.11-0.06-0.25-0.14-0.37-0.23c-1.49-1.18-3.13-2.51-4.54-3.66c-2.06-1.69-4.43-3.64-6.09-5.02 c-1.13-0.93-2.42-1.58-3.63-1.83c-0.79-0.14-1.49-0.14-2.06,0.08c-0.45,0.2-0.85,0.56-1.1,1.13c-0.34,0.76-0.51,1.83-0.42,3.3 c0.08,1.3,0.54,2.71,1.13,4.09c0.87,2,2.09,3.86,2.99,5.04c0.06,0.08,0.11,0.14,0.14,0.23l17.84,25.48 c0.23,0.34,0.37,0.71,0.39,1.07c0.37,2.93,0.99,5.16,1.89,6.54c0.68,1.01,1.52,1.52,2.62,1.49h28.07c1.75-0.03,3.33-0.53,4.79-1.55 c1.61-1.1,3.04-2.82,4.37-5.13c0.03-0.03,0.06-0.08,0.08-0.11c0.51-0.87,1.18-2,1.83-3.07c2.85-4.68,5.33-8.77,5.61-14.57l-0.17-8 c-0.03-0.11-0.03-0.23-0.03-0.34s0-0.87,0.03-1.89c0.06-5.3,0.14-11.84-4.71-12.65h-3.13c-0.03,1.49-0.11,3.02-0.2,4.48 c-0.08,1.32-0.17,2.56-0.17,3.78c0,1.3-1.04,2.34-2.34,2.34c-1.3,0-2.34-1.04-2.34-2.34c0-1.21,0.08-2.62,0.17-4.09 c0.31-4.99,0.68-10.71-3.3-11.41h-3.1c-0.17,0-0.34-0.03-0.51-0.06c0.03,1.8-0.08,3.66-0.2,5.47C60.08,70.46,60,71.7,60,72.91 c0,1.3-1.04,2.34-2.34,2.34c-1.3,0-2.34-1.04-2.34-2.34c0-1.21,0.08-2.62,0.17-4.09c0.31-4.99,0.68-10.71-3.3-11.41h-3.1 c-0.23,0-0.42-0.03-0.62-0.08v9.1c0,1.3-1.04,2.34-2.34,2.34c-1.3,0-2.34-1.04-2.34-2.34V41.99c0-4.09-1.66-6.68-3.8-7.75 c-0.79-0.4-1.63-0.59-2.45-0.59c-0.82,0-1.66,0.2-2.45,0.59c-2.11,1.07-3.75,3.66-3.75,7.86v42.81c0,1.3-1.04,2.34-2.34,2.34 c-1.3,0-2.34-1.04-2.34-2.34v-4.34H26.6L26.6,80.57z M39.29,13.99c0,1.55-1.26,2.78-2.78,2.78c-1.55,0-2.78-1.26-2.78-2.78V2.78 c0-1.55,1.26-2.78,2.78-2.78c1.55,0,2.78,1.26,2.78,2.78V13.99L39.29,13.99L39.29,13.99z M13.99,36.95c1.55,0,2.78,1.26,2.78,2.78 c0,1.55-1.26,2.78-2.78,2.78H2.78C1.23,42.5,0,41.24,0,39.73c0-1.55,1.26-2.78,2.78-2.78H13.99L13.99,36.95z M21.92,20.33 c1.08,1.08,1.08,2.85,0,3.93c-1.08,1.08-2.85,1.08-3.93,0l-7.9-7.93c-1.08-1.08-1.08-2.85,0-3.93c1.08-1.08,2.85-1.08,3.93,0 L21.92,20.33L21.92,20.33z M58.47,42.5c-1.55,0-2.78-1.26-2.78-2.78c0-1.55,1.26-2.78,2.78-2.78h11.21c1.55,0,2.78,1.26,2.78,2.78 c0,1.55-1.26,2.78-2.78,2.78H58.47L58.47,42.5z M54.47,23.65c-1.08,1.08-2.85,1.08-3.93,0c-1.08-1.08-1.08-2.85,0-3.93l7.9-7.93 c1.08-1.08,2.85-1.08,3.93,0c1.08,1.08,1.08,2.85,0,3.93L54.47,23.65L54.47,23.65z M48.47,52.79c0.2-0.06,0.39-0.08,0.62-0.08h3.24 c0.17,0,0.37,0.03,0.53,0.06c4.31,0.68,6.26,3.19,7.05,6.45c0.31-0.14,0.65-0.23,0.99-0.23h3.24c0.17,0,0.37,0.03,0.53,0.06 c4.65,0.73,6.51,3.58,7.19,7.19c0.11-0.03,0.23-0.03,0.37-0.03h3.24c0.17,0,0.37,0.03,0.54,0.06c8.91,1.38,8.79,10.23,8.71,17.36 v1.86l0.2,8.23v0.25c-0.34,7.02-3.1,11.56-6.28,16.8c-0.54,0.87-1.07,1.77-1.8,3.02c-0.03,0.03-0.03,0.06-0.06,0.08 c-1.66,2.9-3.58,5.13-5.78,6.65c-2.23,1.55-4.71,2.34-7.41,2.37H35.53c-2.79,0.06-4.96-1.16-6.57-3.55c-1.3-1.92-2.14-4.62-2.59-8 L8.9,86.35l-0.09-0.08c-1.04-1.38-2.45-3.55-3.52-5.95c-0.79-1.8-1.38-3.75-1.52-5.67c-0.14-2.28,0.17-4.09,0.82-5.52 c0.79-1.78,2.09-2.93,3.64-3.55c1.44-0.59,3.07-0.68,4.71-0.34c1.97,0.4,4,1.38,5.72,2.82c1.41,1.18,3.78,3.1,6.09,4.99l1.92,1.58 V42.13c0-6.23,2.76-10.23,6.34-12.04c1.44-0.73,2.99-1.1,4.57-1.1c1.58,0,3.13,0.37,4.56,1.1c3.58,1.8,6.4,5.83,6.4,11.95v10.76 L48.47,52.79L48.47,52.79z" />
    </g>
  </svg>
);

export const emailIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.877"
    height="13.617"
    viewBox="0 0 17.877 13.617"
  >
    <g id="email" transform="translate(0 -61)">
      <g id="Group_19" data-name="Group 19" transform="translate(0 61)">
        <path
          id="Path_28"
          data-name="Path 28"
          d="M16.306,61H1.571A1.574,1.574,0,0,0,0,62.571V73.046a1.574,1.574,0,0,0,1.571,1.571H16.306a1.574,1.574,0,0,0,1.571-1.571V62.571A1.574,1.574,0,0,0,16.306,61Zm-.217,1.047L8.972,69.164,1.793,62.047ZM1.047,72.829V62.783l5.045,5Zm.741.741,5.048-5.048L8.6,70.275a.524.524,0,0,0,.739,0l1.725-1.725,5.02,5.02Zm15.041-.741-5.02-5.02,5.02-5.02Z"
          transform="translate(0 -61)"
        />
      </g>
    </g>
  </svg>
);

export const userIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.354"
    height="18.404"
    viewBox="0 0 15.354 18.404"
  >
    <g id="user" transform="translate(0 0)">
      <path
        id="Path_109"
        data-name="Path 109"
        d="M91.464,8.865a4.289,4.289,0,0,0,3.134-1.3,4.289,4.289,0,0,0,1.3-3.134A4.289,4.289,0,0,0,94.6,1.3a4.432,4.432,0,0,0-6.268,0,4.289,4.289,0,0,0-1.3,3.134,4.289,4.289,0,0,0,1.3,3.134A4.29,4.29,0,0,0,91.464,8.865Zm-2.371-6.8a3.353,3.353,0,0,1,4.743,0,3.2,3.2,0,0,1,.983,2.371A3.2,3.2,0,0,1,93.836,6.8a3.353,3.353,0,0,1-4.743,0,3.2,3.2,0,0,1-.983-2.371,3.2,3.2,0,0,1,.983-2.371Zm0,0"
        transform="translate(-83.904)"
      />
      <path
        id="Path_110"
        data-name="Path 110"
        d="M15.317,252.578a10.948,10.948,0,0,0-.149-1.163,9.161,9.161,0,0,0-.286-1.169,5.775,5.775,0,0,0-.481-1.09,4.11,4.11,0,0,0-.725-.945,3.2,3.2,0,0,0-1.041-.654,3.6,3.6,0,0,0-1.329-.241,1.349,1.349,0,0,0-.72.306c-.216.141-.469.3-.75.484a4.3,4.3,0,0,1-.971.428,3.771,3.771,0,0,1-2.375,0,4.287,4.287,0,0,1-.97-.428c-.279-.178-.532-.341-.751-.484a1.348,1.348,0,0,0-.72-.306,3.593,3.593,0,0,0-1.329.241,3.193,3.193,0,0,0-1.041.654,4.111,4.111,0,0,0-.725.944,5.786,5.786,0,0,0-.481,1.091,9.184,9.184,0,0,0-.286,1.169,10.874,10.874,0,0,0-.149,1.163C.012,252.93,0,253.3,0,253.665a3.056,3.056,0,0,0,.908,2.312,3.267,3.267,0,0,0,2.339.853h8.861a3.267,3.267,0,0,0,2.339-.853,3.055,3.055,0,0,0,.908-2.312c0-.371-.013-.737-.037-1.087ZM13.7,255.2a2.2,2.2,0,0,1-1.6.556H3.246a2.2,2.2,0,0,1-1.6-.556,2,2,0,0,1-.573-1.531c0-.345.011-.685.034-1.012a9.808,9.808,0,0,1,.135-1.047,8.1,8.1,0,0,1,.251-1.031,4.711,4.711,0,0,1,.391-.887,3.047,3.047,0,0,1,.533-.7,2.12,2.12,0,0,1,.693-.431,2.481,2.481,0,0,1,.849-.164c.038.02.105.058.214.129.222.144.477.309.76.49a5.343,5.343,0,0,0,1.219.545,4.848,4.848,0,0,0,3.039,0,5.35,5.35,0,0,0,1.22-.545c.289-.185.537-.345.759-.489.109-.071.176-.109.214-.129a2.483,2.483,0,0,1,.85.164,2.123,2.123,0,0,1,.692.431,3.039,3.039,0,0,1,.533.7,4.694,4.694,0,0,1,.391.886,8.081,8.081,0,0,1,.252,1.031,9.891,9.891,0,0,1,.135,1.048h0c.023.326.034.666.035,1.012A2,2,0,0,1,13.7,255.2Zm0,0"
        transform="translate(0 -238.426)"
      />
    </g>
  </svg>
);

export const phoneIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.17"
    height="18.197"
    viewBox="0 0 18.17 18.197"
  >
    <g id="phone-call" transform="translate(-0.344 0)">
      <g id="Group_83" data-name="Group 83" transform="translate(0.344 0)">
        <path
          id="Path_111"
          data-name="Path 111"
          d="M14.712,37.626a1.79,1.79,0,0,0-1.3-.6,1.851,1.851,0,0,0-1.313.591l-1.214,1.21c-.1-.054-.2-.1-.3-.154-.138-.069-.269-.134-.38-.2a13.19,13.19,0,0,1-3.161-2.88,7.782,7.782,0,0,1-1.037-1.636c.315-.288.607-.588.891-.876.108-.108.215-.219.323-.326a1.762,1.762,0,0,0,0-2.658L6.179,29.05c-.119-.119-.242-.242-.357-.365-.23-.238-.472-.484-.722-.714a1.818,1.818,0,0,0-1.287-.565,1.881,1.881,0,0,0-1.306.565l-.008.008L1.194,29.3A2.81,2.81,0,0,0,.36,31.081a6.733,6.733,0,0,0,.492,2.85,16.536,16.536,0,0,0,2.938,4.9,18.073,18.073,0,0,0,6.018,4.712,9.377,9.377,0,0,0,3.38,1c.081,0,.165.008.242.008a2.894,2.894,0,0,0,2.216-.952c0-.008.012-.012.015-.019a8.732,8.732,0,0,1,.672-.7c.165-.157.334-.323.5-.5a1.916,1.916,0,0,0,.58-1.329,1.846,1.846,0,0,0-.591-1.317Zm1.375,4.044s0,0,0,0c-.15.161-.3.307-.469.469a10.1,10.1,0,0,0-.741.768,1.851,1.851,0,0,1-1.444.611c-.058,0-.119,0-.177,0a8.33,8.33,0,0,1-3-.9,17.06,17.06,0,0,1-5.669-4.44,15.592,15.592,0,0,1-2.765-4.6,5.484,5.484,0,0,1-.43-2.4,1.763,1.763,0,0,1,.53-1.141l1.31-1.31a.873.873,0,0,1,.584-.273.822.822,0,0,1,.561.269l.012.012c.234.219.457.446.691.687.119.123.242.246.365.373L6.5,30.832a.733.733,0,0,1,0,1.191c-.111.111-.219.223-.33.33-.323.33-.63.638-.964.937-.008.008-.015.012-.019.019a.783.783,0,0,0-.2.872L5,34.215a8.418,8.418,0,0,0,1.241,2.024l0,0a14.1,14.1,0,0,0,3.41,3.1,5.243,5.243,0,0,0,.472.257c.138.069.269.134.38.2.015.008.031.019.046.027a.833.833,0,0,0,.38.1.821.821,0,0,0,.584-.265l1.313-1.313a.869.869,0,0,1,.58-.288.782.782,0,0,1,.553.28l.008.008,2.116,2.116A.759.759,0,0,1,16.087,41.67Z"
          transform="translate(-0.344 -26.353)"
        />
        <path
          id="Path_112"
          data-name="Path 112"
          d="M245.371,86.954a4.943,4.943,0,0,1,4.025,4.025.515.515,0,0,0,.511.43.685.685,0,0,0,.088-.008.519.519,0,0,0,.426-.6,5.977,5.977,0,0,0-4.87-4.87.521.521,0,0,0-.6.422A.513.513,0,0,0,245.371,86.954Z"
          transform="translate(-235.55 -82.625)"
        />
        <path
          id="Path_113"
          data-name="Path 113"
          d="M257.4,8.027A9.841,9.841,0,0,0,249.378.008a.518.518,0,1,0-.169,1.022A8.79,8.79,0,0,1,256.375,8.2a.515.515,0,0,0,.511.43.687.687,0,0,0,.088-.008A.509.509,0,0,0,257.4,8.027Z"
          transform="translate(-239.234 0)"
        />
      </g>
    </g>
  </svg>
);

export const greenCheck = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.217"
    height="15.237"
    viewBox="0 0 15.217 15.237"
  >
    <g id="checked" transform="translate(-0.301 0)">
      <path
        id="Path_2010"
        data-name="Path 2010"
        d="M13.857,14.462c-2.332,1.9-9.612,1.9-11.9,0-2.332-1.9-2.094-10.04,0-12.181s9.8-2.141,11.9,0S16.189,12.559,13.857,14.462Z"
        transform="translate(0 -0.652)"
        fill="#8dc640"
      />
      <g
        id="Group_1227"
        data-name="Group 1227"
        transform="translate(0.308 0)"
        opacity="0.2"
      >
        <path
          id="Path_2011"
          data-name="Path 2011"
          d="M8.158,10.479a11.141,11.141,0,0,1-6.614,2.569C-.073,10.289.26,3.58,2.163,1.629,3.876-.132,9.253-.465,12.346.63,13.107,3.77,11.537,7.767,8.158,10.479Z"
          transform="translate(-0.509 0)"
          fill="#fff"
        />
      </g>
      <path
        id="Path_2012"
        data-name="Path 2012"
        d="M86.5,109.855a1.017,1.017,0,0,1-.856-.428L82.974,106a1.085,1.085,0,0,1,1.713-1.332L86.5,107l4-5.187a1.085,1.085,0,0,1,1.713,1.332l-4.853,6.281A1.245,1.245,0,0,1,86.5,109.855Z"
        transform="translate(-79.68 -97.996)"
        fill="#fff"
      />
    </g>
  </svg>
);

export const infoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    viewBox="0 0 50 50"
    width="50px"
    height="50px"
  >
    <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z" />
  </svg>
);
